import { memo } from 'react';

import { ACTION_TYPES } from 'ui/actions/action-config';
import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.journey_loop;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <JourneyIconButton
        node={node}
        color={node.data.isSkipped ? 'purple40' : 'teal100'}
        isSelectable
      />
    </NodeContainer>
  );
});
